import { FC, ReactElement } from 'react'
import {
  RedRed50,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { SequenceMenu } from '@sequencehq/core-components'

export const CancelAutomationMenuItem = ({
  onSubmit,
  automationExecutionId
}: {
  onSubmit?: () => void
  automationExecutionId: string
}) => {
  return (
    <CancelAutomationModal
      automationExecutionId={automationExecutionId}
      trigger={
        <SequenceMenu.Item
          uuid="cancel-automation"
          label="Cancel workflow"
          data-testid="quotes.cancelAutomation.menuItem"
          style={{ color: RedRed50 }}
        />
      }
      onSubmit={onSubmit}
    />
  )
}

export const CancelAutomationModal: FC<{
  trigger: ReactElement
  onSubmit?: () => void
  automationExecutionId?: string
}> = ({ trigger, onSubmit, automationExecutionId }) => {
  const { displayNotification } = useNotifications()

  return (
    <SimpleModal
      variant="dialog"
      trigger={trigger}
      onSubmit={async () => {
        try {
          if (!automationExecutionId) {
            throw new Error('automationExecutionId is undefined')
          }

          const res =
            await dashboardv99990101Client.postCancelAutomationExecution({
              id: automationExecutionId
            })

          if (res.error) {
            throw new Error('Unable to cancel automation execution')
          }

          onSubmit?.()

          displayNotification('Workflow successfully cancelled', {
            type: 'success'
          })

          return true
        } catch {
          displayNotification('Failed to cancel workflow', {
            type: 'error'
          })
          return false
        }
      }}
      title="Are you sure you want to cancel this workflow?"
      submitButtonText="Cancel workflow"
      isDestructive
    >
      This will cancel any pending tasks for this workflow.
    </SimpleModal>
  )
}
